/*
 * @Author: your name
 * @Date: 2022-01-12 10:43:35
 * @LastEditTime: 2022-01-12 10:46:14
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \wp-empowerment-tools-web\src\services\scriptLibrary.ts
 */

import { SCRIPT_LIBRARY } from "../const"
import request from "../utils/request"
const queryByParams = (params: any) => {
  return request.post(`${SCRIPT_LIBRARY.queryByParams}`, { data: params })
}

const getEnterpriseChatGroupList = () => {
  return request.get(`${SCRIPT_LIBRARY.getEnterpriseChatGroupList}`)
}

const getEnterpriseChatKeywordByPage = (data: any) => {
  return request.post(`${SCRIPT_LIBRARY.getEnterpriseChatKeywordByPage}`, {
    data,
  })
}

const getPageChatGroup = (params: any) => {
  return request.post(`${SCRIPT_LIBRARY.getPageChatGroup}`, { data: params })
}

const addChatGroup = (params: any) => {
  return request.post(`${SCRIPT_LIBRARY.addChatGroup}`, { data: params })
}

const updateChatGroup = (params: any) => {
  return request.post(`${SCRIPT_LIBRARY.updateChatGroup}`, { data: params })
}

const batchDeleteByIdChatGroup = (params: any) => {
  return request.post(`${SCRIPT_LIBRARY.batchDeleteByIdChatGroup}`, {
    data: params,
  })
}

const getPageDialogueAll = (params: any) => {
  return request.post(`${SCRIPT_LIBRARY.getPageDialogueAll}`, { data: params })
}

const addDialogueAndChatContent = (params: any) => {
  return request.post(`${SCRIPT_LIBRARY.addDialogueAndChatContent}`, {
    data: params,
  })
}

const updateDialogueAndChatContent = (params: any) => {
  return request.post(`${SCRIPT_LIBRARY.updateDialogueAndChatContent}`, {
    data: params,
  })
}

const batchDeleteByIdDialogue = (params: any) => {
  return request.post(`${SCRIPT_LIBRARY.batchDeleteByIdDialogue}`, {
    data: params,
  })
}

const collectEnterpriseDialogueById = (params: any) => {
  return request.post(`${SCRIPT_LIBRARY.collectEnterpriseDialogueById}`, {
    requestType: "form",
    data: params,
  })
}

//
const parseLinkArticle = (data: any) => {
  return request.get(`${SCRIPT_LIBRARY.parseLinkArticle}`, { params: data })
}
//
const queryGoodsByParams = (params: any) => {
  return request.post(SCRIPT_LIBRARY.queryGoodsByParams, {
    data: params,
  })
}
//
const querySourceByParams = (params: any) => {
  return request.post(SCRIPT_LIBRARY.querySourceByParams, {
    data: params,
  })
}
//
const uploadQywxFile = (params: any) => {
  return request.post(`${SCRIPT_LIBRARY.uploadQywxFile}`, {
    requestType: "form",
    data: params,
  })
}

const getSearchDialogue = (data: any) => {
  return request.post(`${SCRIPT_LIBRARY.getSearchDialogue}`, {
    data,
    timeout: 7000,
  })
}

export {
  queryByParams,
  getEnterpriseChatGroupList,
  getEnterpriseChatKeywordByPage,
  getPageChatGroup,
  addChatGroup,
  updateChatGroup,
  batchDeleteByIdChatGroup,
  getPageDialogueAll,
  collectEnterpriseDialogueById,
  addDialogueAndChatContent,
  updateDialogueAndChatContent,
  batchDeleteByIdDialogue,
  parseLinkArticle,
  queryGoodsByParams,
  querySourceByParams,
  uploadQywxFile,
  getSearchDialogue,
}
